import _mergeJSXProps from 'babel-helper-vue-jsx-merge-props';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
// import PropTypes from '../_util/vue-types';
import BaseMixin from '../_util/BaseMixin';
import Base from '../base';
import Icon from '../icon';
import SelectTrigger from './SelectTrigger';
import CascaderPropTypes from '../cascader/CascaderPropTypes';
import { hasProp, getOptionProps, getComponentFromProp } from '../_util/props-util';
import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
import Omit from 'omit.js';

var CascaderTable = {
  inheritAttrs: false,
  name: 'ACascaderTable',
  componentName: 'CascaderTable',
  mixins: [BaseMixin],
  props: CascaderPropTypes,
  model: {
    prop: 'value',
    event: 'change'
  },
  inject: {
    configProvider: { 'default': function _default() {
        return ConfigConsumerProps;
      } },
    localeData: { 'default': function _default() {} }
  },
  data: function data() {
    var value = this.value,
        open = this.open,
        defaultValue = this.defaultValue;

    return {
      _value: value || defaultValue || [],
      _open: open
    };
  },

  watch: {
    value: function value(val) {
      this.setState({ _value: val || [] });
    },
    open: function open(_open) {
      this.setState({ _open: _open });
    }
  },
  methods: {
    handleChange: function handleChange(value, selectedOptions) {
      if (!hasProp(this, 'value')) {
        this.setState({ _value: value });
      }
      this.$emit('change', value, selectedOptions);
    },
    handleCheck: function handleCheck(eventObj) {
      this.$emit('check', eventObj);
    },
    handleRemove: function handleRemove(eventObj) {
      this.$emit('remove', eventObj);
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    },
    handleReset: function handleReset(value) {
      this.$emit('reset', value);
    },
    handleTabChange: function handleTabChange(value) {
      this.$emit('tabChange', value);
    },
    handleSearch: function handleSearch(value) {
      this.$emit('search', value);
    },
    handlePopupVisibleChange: function handlePopupVisibleChange(open) {
      if (!hasProp(this, 'open')) {
        this.setState(function () {
          return {
            _open: open
          };
        });
      }
      this.$emit('popupVisibleChange', open);
    },
    onReset: function onReset() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.selectTriggerRef.onReset();
      });
    },
    getCheckedNodes: function getCheckedNodes() {
      var fieldNames = this.$props.fieldNames;

      var selected = this.$refs.selectTriggerRef.$data._selectorValueList;
      return selected.map(function (_ref) {
        var _extends2;

        var key = _ref.key,
            value = _ref.value,
            label = _ref.label,
            rest = _objectWithoutProperties(_ref, ['key', 'value', 'label']);

        return _extends((_extends2 = {}, _defineProperty(_extends2, fieldNames.value, value), _defineProperty(_extends2, fieldNames.label, label), _extends2), rest);
      });
    },
    getCheckedKeys: function getCheckedKeys() {
      var fieldNames = this.$props.fieldNames;

      return this.getCheckedNodes().map(function (o) {
        return o[fieldNames.value];
      });
    }
  },
  render: function render() {
    var _cls;

    var h = arguments[0];
    var $scopedSlots = this.$scopedSlots;
    var _$data = this.$data,
        value = _$data._value,
        open = _$data._open;

    var props = getOptionProps(this);

    var customizePrefixCls = props.prefixCls,
        customizeSelectPrefixCls = props.selectPrefixCls,
        size = props.size,
        notFoundContent = props.notFoundContent,
        restProps = _objectWithoutProperties(props, ['prefixCls', 'selectPrefixCls', 'size', 'notFoundContent']);

    var renderEmpty = this.configProvider.renderEmpty;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('cascader-table', customizePrefixCls);
    var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
    var inputPrefixCls = getPrefixCls('input', customizeSelectPrefixCls);
    var removeIcon = getComponentFromProp(this, 'removeIcon');
    var closeIcon = getComponentFromProp(this, 'closeIcon');
    var clearIcon = getComponentFromProp(this, 'clearIcon');
    var searchIcon = getComponentFromProp(this, 'searchIcon');

    var rest = Omit(restProps, ['inputIcon', 'removeIcon', 'closeIcon', 'clearIcon', 'switcherIcon', 'suffixIcon']);
    var suffixIcon = getComponentFromProp(this, 'suffixIcon');
    suffixIcon = Array.isArray(suffixIcon) ? suffixIcon[0] : suffixIcon;

    var inputIcon = suffixIcon || h(Icon, {
      attrs: { type: 'down' },
      'class': selectPrefixCls + '-arrow-icon' });
    var finalRemoveIcon = removeIcon || h(Icon, {
      attrs: { type: 'close' },
      'class': selectPrefixCls + '-remove-icon' });
    var finalCloseIcon = closeIcon || h(Icon, {
      attrs: { type: 'close' },
      'class': selectPrefixCls + '-remove-icon' });
    var finalClearIcon = clearIcon || h(Icon, {
      attrs: { type: 'close-circle', theme: 'filled' },
      'class': selectPrefixCls + '-clear-icon' });
    var cls = (_cls = {}, _defineProperty(_cls, selectPrefixCls + '-lg', size === 'large'), _defineProperty(_cls, selectPrefixCls + '-sm', size === 'small'), _cls);

    var treeData = props.options;

    var displayRender = this.displayRender || $scopedSlots.displayRender;

    var cascaderProps = {
      props: _extends({}, props, rest, {
        prefixCls: prefixCls,
        selectPrefixCls: selectPrefixCls,
        inputPrefixCls: inputPrefixCls,
        treeData: treeData,
        suffixIcon: inputIcon,
        removeIcon: finalRemoveIcon,
        closeIcon: finalCloseIcon,
        clearIcon: finalClearIcon,
        searchIcon: searchIcon,
        displayRender: displayRender,
        value: value,
        open: open,
        notFoundContent: notFoundContent || renderEmpty(h, 'Cascader')
      }),
      'class': cls,
      on: {
        popupVisibleChange: this.handlePopupVisibleChange,
        change: this.handleChange,
        cancel: this.handleCancel,
        reset: this.handleReset,
        tabChange: this.handleTabChange,
        search: this.handleSearch,
        check: this.handleCheck,
        remove: this.handleRemove
      },
      scopedSlots: $scopedSlots
    };
    return h(SelectTrigger, _mergeJSXProps([{ ref: 'selectTriggerRef' }, cascaderProps]));
  }
};

/* istanbul ignore next */
CascaderTable.install = function (Vue) {
  Vue.use(Base);
  Vue.component(CascaderTable.name, CascaderTable);
};

export default CascaderTable;